import { theme } from 'lib/style';
import styled from 'styled-components/macro';

export const Label = styled.label`
  display: flex;
  height: 20px;
  ${theme.fontNormal500}
  color: ${props => props.theme.colors.neutral[60]};
  font-size: 14px;
  line-height: 20px;
`;

export const SecondaryLabel = styled.label`
  display: flex;
  ${theme.fontNormal600}
  color: ${props => props.theme.colors.neutral[80]};
  font-size: 12px;
`;

type ColorBlockProps = {
  color: string;
  readonly?: boolean;
};

export const ColorBlock = styled.div<ColorBlockProps>`
  width: 34px;
  height: 34px;
  border: 1px solid ${props => props.theme.colors.primary[20]};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  background: ${props => props.color};
  pointer-events: ${({ readonly }) => (readonly ? 'none' : 'all')};
`;

export const ColorInput = styled.input<{ readonly?: boolean }>`
  border: none;
  background: none;
  outline: none;
  font: inherit;
  border: 1px solid ${props => props.theme.colors.primary[20]};
  border-radius: 6px;
  height: 40px;
  width: 168px;
  margin: 0;
  box-sizing: border-box;
  padding: 10px 12px;
  color: ${props => props.theme.colors.neutral[80]};
  font-size: 14px;
  pointer-events: ${({ readonly }) => (readonly ? 'none' : 'all')};
`;

export const OpacityDisplay = styled.div<{ readonly?: boolean }>`
  border: 1px solid ${props => props.theme.colors.primary[20]};
  border-radius: 6px;
  height: 40px;
  width: 60px;
  display: flex;
  align-items: center;
  padding: 10px 12px;
  color: ${props => props.theme.colors.neutral[80]};
  font-size: 14px;
  box-sizing: border-box;
  pointer-events: ${({ readonly }) => (readonly ? 'none' : 'all')};
`;

export const lpBuilderDropdownExtendedStyle = {
  container: {
    width: '100%',
  },
  menu: {
    zIndex: 3,
  },
};

export const Divider = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.neutral[20]};
  height: 1px;
`;
